module.exports = __webpack_public_path__ + "static/media/chevron-circle-left.00c34acc.svg";